import { render } from "./VaBeneMarketingDashPage.vue?vue&type=template&id=27bebb9a&scoped=true&ts=true"
import script from "./VaBeneMarketingDashPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneMarketingDashPage.vue?vue&type=script&lang=ts"

import "./VaBeneMarketingDashPage.vue?vue&type=style&index=0&id=27bebb9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bebb9a"]])

export default __exports__